import { ReactNode } from 'react';
import { SecondaryTitle } from '../../presentation/components/page-title';
import { Sync } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import './dashboard-header.scss';

interface IProps {
  title: string;
  children?: ReactNode;
  loading?: boolean;
}

export const DashboardHeader = ({ title, children, loading }: IProps) => {
  return (
    <div>
      <div className="dashboard-header">
        <SecondaryTitle variant="h3">
          {title}{' '}
          {loading && (
            <Tooltip title="Loading...">
              <Sync className="spin dashboard-header-sync" fontSize="small" />
            </Tooltip>
          )}
        </SecondaryTitle>
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};
